import Table from "src/components/UI/CustomUI/organisms/Table"
import headers from './headers'

const ItemHistory = () => {
  return (
    <Table headers={headers} hasPagination={false}>
      {[]}
    </Table>
  )
}

export default ItemHistory
